import { Dependencies } from 'interface/common.interface';
import { EmailConstraints, EmailStatePayload } from 'interface/email/email.type';

export interface EmailState {
  byRefId: {
    [refId: string]: EmailStateItem;
  };
  allRefId: string[];
}

export enum EMAIL_STORE_ACTION_TYPE {
  UPDATE_EMAIL = 'UPDATE_EMAIL',
  RESET_EMAIL = 'RESET_EMAIL',
}

export enum EMAIL_ACTION_TYPE {
  EMAIL = 'email',
}

export interface EmailStateItem {
  refId: string;
  stepIdx: number;
  actionType: EMAIL_ACTION_TYPE;
  isOptional?: boolean;
  id?: string;
  name?: string;
  payload?: EmailStatePayload;
  payloadType?: 'template' | 'content';
  constraints?: EmailConstraints;
  dependencies?: Dependencies;
  templateId?: string;
  enableOptionalNode?: boolean; //UI
  isReset?: boolean;
}
